import * as WarningsStyles from './Warnings.css';

export default {
	WarningsStyles
};
